import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import ButtonBase from "@mui/material/ButtonBase";

import styles from "./Button.module.scss";

const RegularButton = React.forwardRef((props, ref) => {
  const {
    color,
    round,
    children,
    fullWidth,
    disabled,
    simple,
    simple_box,
    size,
    block,
    link,
    justIcon,
    fileButton,
    className,
    href,
    component,
    ...rest
  } = props;
  const colorClass =
    typeof color === "string" && styles[color.trim()]
      ? styles[color.trim()]
      : null;

  const btnClasses = classNames(
    styles.button,
    {
      [styles[size]]: size,
      [colorClass]: colorClass,
      [styles.round]: round,
      [styles.fullWidth]: fullWidth,
      [styles.disabled]: disabled,
      [styles.simple]: simple,
      [styles.simple_box]: simple_box,
      [styles.block]: block,
      [styles.link]: link,
      [styles.justIcon]: justIcon,
      [styles.fileButton]: fileButton,
    },
    className
  );
  const buttonProps = {
    ...rest,
    disabled,
  };

  if (href) {
    buttonProps.href = href;
    buttonProps.component = component || "a";
  }

  return (
    <ButtonBase {...buttonProps} ref={ref} className={btnClasses}>
      {children}
    </ButtonBase>
  );
});

RegularButton.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "danger",
    "rose",
    "tribalism",
    "white",
    "twitter",
    "facebook",
    "google",
    "linkedin",
    "pinterest",
    "youtube",
    "tumblr",
    "github",
    "behance",
    "dribbble",
    "reddit",
    "instagram",
    "transparent",
    "xxx"
  ]),
  size: PropTypes.oneOf(["sm", "lg"]),
  simple: PropTypes.bool,
  simple_box: PropTypes.bool,
  round: PropTypes.bool,
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  block: PropTypes.bool,
  link: PropTypes.bool,
  justIcon: PropTypes.bool,
  fileButton: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};

export default RegularButton;
